<template>
  <div class="secondpage">
    <div class="title_top">
      <el-row :gutter="20">
        <el-col :span="16" :offset="4">
          <div :class="!isMobile()?'secondpage_con':'secondpage_con_shouji'">
            <h2>规则目录</h2>
            <p></p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 内容 -->
    <el-row class="content" v-show="!isMobile()">
      <el-col :span="16" :offset="4" class="hidden-xs-only">
        <el-row>
          <el-col :xs="24" v-for="cardlist in content">
            <el-card shadow="always">
              <el-row>
                <el-col :xs="12" :sm="6">
                  <img
                    :src="'../../static/' + cardlist.imgsrc"
                    class="image"
                    width="100%"
                  />
                </el-col>
                <el-col :xs="12" :sm="18" class="cont_box2">
                  <h3 style="cursor: pointer" @click="titleHandle(cardlist.url)">
                    {{ cardlist.title }}
                  </h3>
                  <p>{{ cardlist.text }}</p>
                  <p>{{ "发布时间&nbsp&nbsp&nbsp&nbsp" + cardlist.time }}</p>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 手机端 -->
    <div v-show="isMobile()">
      <div class="contontShoji" v-for="cardlist in content"  @click="titleHandle(cardlist.url)">
        <div class="titleShouji">
          <h3>{{cardlist.title}}</h3>
        </div>
        <div class="textShouji">
          <h5>{{cardlist.text}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      workTask: [],
      content: [
        {
          id: 1,
          title: "东方集市用户协议",
          text:
            "欢迎您注册东方集市账号并使用东方集市的服务！本《东方集市用户服务协议》（以下简称“本服务协议”）是您与东方集市之间就注册东方集市用户账号及使用东方集市的各项服务等相关事宜所订立的协议。",
          time: "2023-04-03 09:20",
          imgsrc: "user.png",
		  url:"/userAgreement"
        },
		{
          id: 2,
          title: "东方集市隐私政策",
          text:
            "东方集市（以下或称“我们”）非常注重保护用户（以下或称“您”）的个人信息，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。",
          time: "2023-04-03 09:20",
          imgsrc: "user.png",
		  url:"/concealAgreement"
        },
		{
          id: 3,
          title: "东方集市商户服务规范",
          text:
            "为规范东方集市平台商户服务经营行为，营造合法合规的平台经营环境，保障消费者的合法权益，促进平台内经营者的健康良好发展，维护东方集市平台的正常经营秩序，根据国家法律法规规章，以及东方集市平台与商户间协议和东方集市平台发布的其他规范/规则/管理办法等，制定本规范。",
          time: "2023-04-03 09:20",
          imgsrc: "shangjia.png",
		  url:"/businessAgreement"
        },
		// {
        //   id: 4,
        //   title: "东方集市骑手服务协议",
        //   text:
        //     "欢迎您登录东方集市骑手账号并使用东方集市的服务！本《东方集市骑手服务协议》（以下简称“本服务协议”）是您与东方集市之间就东方集市骑手账号和各项服务的使用等相关事宜所订立的协议。",
        //   time: "2023-04-03 09:20",
        //   imgsrc: "qishou.png",
		//   url:"/horsemanAgreement"
        // },
		// {
        //   id: 5,
        //   title: "东方集市骑手注册协议",
        //   text:
        //     "欢迎您注册东方集市骑手账号并使用东方集市的服务！本《东方集市骑手服务协议》（以下简称“本服务协议”）是您与东方集市之间就注册东方集市骑手账号及使用东方集市的各项服务等相关事宜所订立的协议。",
        //   time: "2023-04-03 09:20",
        //   imgsrc: "qishou.png",
		//   url:"/horsemanLoginAgreement"
        // },
		{
          id: 6,
          title: "青歌传媒：工作不止公司和家的两点一线，还有说走就走的团建活动",
          text:
            "城市无法给予的烟火气，工作无法给予的轻松悠闲，快节奏无法给予的缓慢，我们把这样的生活称之为向往的生活。",
          time: "2022-07-25 18:20",
          imgsrc: "22.jpg",
		  url:"/secondpage"
        },
      ],
    };
  },
  created() {
    this.workTask = this.$route.query.id;
    console.log(this.workTask);
  },
  methods: {
    titleHandle(url) {
      this.$router.push(url);
    },
    isMobile() {
      let flag = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? true : false;
    },
  },
};
</script>

<style scoped>
.title_top {
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #ffffff;
  background: url(../assets/1587_jgzynhtp.jpg) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.content {
  margin: 50px auto;
}
.secondpage_con {
  margin: 150px auto;
}
.secondpage_con_shouji {
  margin: 100px auto;
}
.cont_box2 {
  text-align: left;
  padding-left: 20px;
}
.cont_box2 p {
  color: #bbbbbb;
  font-size: 14px;
}
.el-card {
  margin-top: 20px;
}
.contontShoji {
  background: #ffffff;
  border: 1px solid #ffffff;
  margin: 20px;
  box-shadow: 0px -3px 10px 0px rgba(204, 204, 204, 0.5);  ;
  align-items: center;
  justify-content: center;
padding: 5px;

  
  
}
.titleShouji{
  color: black;
  flex: 1;
}

.textShouji{
	color: #bbb;
	flex: 1;
	width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/newsandinformation.vue